export default __webpack_public_path__ + "65833f8a634615f026fa0d427006b049.png";